import {useContext} from 'react'

import Context from '@s-ui/react-context'
import {useDelayToNextFrame} from '@adv-mt/mt-hook-use-delay-to-next-frame'
import {useAnalyticsTrack} from '@adv-mt/mt-tracking-use-analytics'
import {Button, BUTTON_INTENTS, BUTTON_SHAPES, BUTTON_SIZES, BUTTON_VARIANTS} from '@adv-mt/ui/button'
import {DECODING, LOADING, MediaImage, OBJECT_FIT} from '@adv-mt/ui/media-image'
import {Body1, Body2} from '@adv-mt/ui/typography'

import {BASE_CLASS} from './FormFields.js'

const SuccessAppDownload = () => {
  const {i18n, domain} = useContext(Context)
  const {track: analyticsTrack} = useAnalyticsTrack()
  const delayToNextFrame = useDelayToNextFrame()
  const config = domain.get('config')
  const isMobile = config.get('isMobile')
  const osName = config.get('osName')
  const {MOBILE_ASSET_PATH, MOBILE_INSTALL_URL, DESKTOP_QR_CODE_PATH} = config.get('webToApp')
  const assetPath = isMobile ? MOBILE_ASSET_PATH : DESKTOP_QR_CODE_PATH

  if (!assetPath) {
    return null
  }

  const handleInstallClick = () => {
    const {
      HIT_ORIGINS: hitOrigins,
      TRACKING_EVENT_NAMES: trackingEventNames,
      TRACKING_OS_NAMES: trackingOsNames
    } = config.get('tracking')

    delayToNextFrame(() => {
      analyticsTrack({
        event: trackingEventNames.APP_DOWNLOAD_BUTTON_CLICKED,
        data: {
          hit_origin: hitOrigins.APP_DOWNLOAD_FROM_POST_LEAD,
          hit_information: trackingOsNames[osName]
        }
      })
    })
  }

  const imageSize = isMobile ? 96 : 120

  const illustration = (
    <MediaImage
      alt={isMobile ? '' : i18n.t('LEAD.QR_CODE_ALT')}
      className={`${BASE_CLASS}-app${isMobile ? 'Illustration' : 'QrImage'}`}
      decoding={DECODING.ASYNC}
      height={imageSize}
      loading={LOADING.LAZY}
      objectFit={OBJECT_FIT.CONTAIN}
      src={`${config.get('URL_STATICS_IMAGES')}${assetPath}`}
      width={imageSize}
    />
  )

  const copy = (
    <div className={`${BASE_CLASS}-appCopy`}>
      <Body1 className={`${BASE_CLASS}-appTitle`} highlight>
        {i18n.t('CONTACT_SELLER_V2.SUCCESS.APP_TITLE')}
      </Body1>
      <Body2 className={`${BASE_CLASS}-appBody`}>
        {i18n.t(isMobile ? 'CONTACT_SELLER_V2.SUCCESS.APP_BODY_MOBILE' : 'CONTACT_SELLER_V2.SUCCESS.APP_BODY_DESKTOP')}
      </Body2>
    </div>
  )

  if (!isMobile) {
    return (
      <div className={`${BASE_CLASS}-app`}>
        {copy}
        {illustration}
      </div>
    )
  }

  return (
    <div className={`${BASE_CLASS}-app ${BASE_CLASS}-app--mobile`}>
      <div className={`${BASE_CLASS}-appRow`}>
        {illustration}
        {copy}
      </div>
      <Button
        fullWidth
        href={MOBILE_INSTALL_URL}
        intent={BUTTON_INTENTS.PRIMARY}
        shape={BUTTON_SHAPES.CIRCLE}
        size={BUTTON_SIZES.MEDIUM}
        target="_blank"
        rel="noopener noreferrer"
        variant={BUTTON_VARIANTS.SOLID}
        onClick={handleInstallClick}
      >
        {i18n.t('CONTACT_SELLER_V2.SUCCESS.APP_CTA_MOBILE')}
      </Button>
    </div>
  )
}

SuccessAppDownload.displayName = 'ContactFormV2SuccessAppDownload'

export default SuccessAppDownload
